import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Login from './screens/Login';
import Home from './screens/Home';
import Navbar from './components/Navbar';
import AboutUs from './screens/AboutUs';
import ContactUs from './screens/ContactUs';
import Services from './screens/Services';
import ScrollToTop from './components/ScrollToTop';
import InvestorEducation from './screens/InvestorEducation';
import SipCalculator from './components/SipCalculator';
import Disclaimer from './screens/Disclaimer';
import Disclosure from './screens/Disclosure';
import Grievance from './screens/Grievance';
import Footer from './components/Footer';
import Blog from './components/Blog';
import BlogAdd from './components/BlogAdd';
import BlogDetail from './components/BlogDetail';
import AdminLogin from './screens/AdminLogin';
import StatutoryWarning from './components/StatutoryWarning';
import StatutoryWarningAdd from './components/StatutoryWarningAdd';
import StatutoryWarningDetail from './components/StatutoryWarningDetail';

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/services/*" element={<Services />} />
        <Route path="/investor-education" element={<InvestorEducation />} />
        <Route path="/financial-calculator" element={<SipCalculator />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/disclosure" element={<Disclosure />} />
        <Route path="/grievance-redressal" element={<Grievance />} />
        <Route path="/admin" element={<AdminLogin />} />

        {/* Blog Routes */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-add" element={<BlogAdd />} />
        <Route path="/blog/:id" element={<BlogDetail />} />

        {/* ADDED: Statutory Warning Routes */}
        <Route path="/statutory-warning" element={<StatutoryWarning />} />
        <Route path="/statutory-warning-add" element={<StatutoryWarningAdd />} />
        <Route path="/statutory-warning/:id" element={<StatutoryWarningDetail />} />
        
      </Routes>
      <Footer/>
      <ScrollToTop />
    </>
  );
};

export default App;